<div class="page-container gap-24">
  <div class="page-title">Dozierende</div>

  <div class="flex-c gap-12">
    <span class="align-self-stretch font-medium-headline-medium">
      Hier stellen wir euch unsere Dozierenden vor.
    </span>
    <span class="align-self-stretch font-regular-body-large">
      Unsere Fortbildungen leben von den Menschen, die sie gestalten mit ihrer
      Erfahrung, ihrem Fachwissen und vor allem ihrer Persönlichkeit.
    </span>
  </div>

  @if (loading) {
    <div class="lecturers-grid">
      @for (item of [1, 2, 3]; track item) {
        <p-skeleton borderRadius="12px" width="100%" height="490px" />
      }
    </div>
  } @else if (lecturers.length === 0) {
    <span class="font-regular-body-large">
      Aktuell sind keine Dozierenden mit laufenden oder buchbaren Seminaren
      verfügbar.
    </span>
  } @else {
    <div class="lecturers-grid">
      @for (lecturer of lecturers; track lecturer.id) {
        <app-lecturer-card [lecturer]="lecturer"></app-lecturer-card>
      }
    </div>
  }
</div>
